import { CommonEnums } from '../../common.enums';

export class Param {
    param_Id: number;
    obj_Id: number;
    nm: string;
    paramNm: string;
    paramPrec: number;
    paramScale: number;
    paramDTyp_Id: number;
    paramVal: string;
    valid_Cd: string;
    srt_Order: number;

    /** there are types of params */
    paramTyp: string;
    type: string;
    prm_Lnk_Obj_Id: number;
    paramDefVal: string;
    conn_Id: number;
    conn_Db_Id: number;
    jobId: number;
    //   job_Id: number;
    jobOrder: string;
    copyParamVal: string;
    copyValid_Cd: string;
    ref_Id: number;
    error_Cd: string;
    error_Msg: String;
    conn_Nm: string;
    conn_Db_Nm: string;
    conn_Fldr_Id: string;
    paramDTyp_Nm: string;
    showParamPrec: boolean;
    showParamScale: boolean;
    maxParamPrec: number;
    maxParamScale: number;
    prm_Lnk_Obj_Nm: string;
    hideParamDTyp_Id: boolean;
    isEditable: string;
    fldr_Id: number;
    fldrNm: string;
    change_Ind: string;
    ref_Cd: string;
    selectedFlag: string;
    recExists: boolean;
    forcibleFlag: string;
    isFileType: string;

    constructor() {
        this.setDefaults();
    }

    setDefaults(): void {
        this.param_Id = CommonEnums.defaults.LONG_VAL;
        this.obj_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.paramNm = CommonEnums.defaults.STRING_VAL_NO;
        this.paramPrec = CommonEnums.defaults.LONG_VAL;
        this.paramScale = CommonEnums.defaults.LONG_VAL;
        this.paramDTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.paramVal = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.srt_Order = CommonEnums.defaults.LONG_VAL;
        this.type = "General Configuration";
        this.prm_Lnk_Obj_Id = CommonEnums.defaults.LONG_VAL;
        this.paramDefVal = "NULL";
        this.conn_Id = CommonEnums.defaults.LONG_VAL;
        this.conn_Db_Id = CommonEnums.defaults.LONG_VAL;
        this.jobId = CommonEnums.defaults.LONG_VAL;
        //      this.job_Id = CommonEnums.defaults.LONG_VAL;
        this.conn_Id = CommonEnums.defaults.LONG_VAL;
        this.jobOrder = CommonEnums.defaults.STRING_EMPTY;
        this.copyParamVal = CommonEnums.defaults.STRING_EMPTY;
        this.copyValid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Nm = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Db_Nm = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Fldr_Id = CommonEnums.defaults.STRING_EMPTY;
        this.paramDTyp_Nm = CommonEnums.defaults.STRING_EMPTY;
        this.showParamPrec = false;
        this.showParamScale = false;
        this.maxParamPrec = CommonEnums.defaults.LONG_VAL;
        this.maxParamScale = CommonEnums.defaults.LONG_VAL;
        this.prm_Lnk_Obj_Nm = CommonEnums.defaults.STRING_EMPTY;
        this.hideParamDTyp_Id = false;
        this.isEditable = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.selectedFlag = CommonEnums.defaults.STRING_EMPTY;
        this.recExists = false;
        this.forcibleFlag = CommonEnums.defaults.STRING_EMPTY;
        this.isFileType = 'N';
    }

    static parse(paramTmp: any): Param {
        let param: Param = new Param();
        param.copyFrom(paramTmp as Param);
        return param;
    }
    getPrimaryKey(): string {
        return this.param_Id + '.' + this.obj_Id + '.' + this.paramTyp;
    }

    copy(): Param {
        let paramTmp: Param = new Param();

        paramTmp.param_Id = this.param_Id;
        paramTmp.obj_Id = this.obj_Id;
        paramTmp.nm = this.nm;
        paramTmp.paramNm = this.paramNm;
        paramTmp.paramPrec = this.paramPrec;
        paramTmp.paramScale = this.paramScale;
        paramTmp.type = this.type;
        paramTmp.paramDTyp_Id = this.paramDTyp_Id;
        paramTmp.paramVal = this.paramVal;
        paramTmp.valid_Cd = this.valid_Cd;
        paramTmp.srt_Order = this.srt_Order;
        paramTmp.paramTyp = this.paramTyp;
        paramTmp.prm_Lnk_Obj_Id = this.prm_Lnk_Obj_Id;
        paramTmp.paramDefVal = this.paramDefVal;

        paramTmp.conn_Id = this.conn_Id;
        paramTmp.conn_Db_Id = this.conn_Db_Id;
        paramTmp.jobId = this.jobId;
        //      paramTmp.job_Id = this.job_Id;
        paramTmp.jobOrder = this.jobOrder;
        paramTmp.copyParamVal = this.copyParamVal;
        paramTmp.copyValid_Cd = this.copyValid_Cd;
        paramTmp.ref_Id = this.ref_Id;
        paramTmp.error_Cd = this.error_Cd;
        paramTmp.error_Msg = this.error_Msg;
        paramTmp.conn_Nm = this.conn_Nm;
        paramTmp.conn_Db_Nm = this.conn_Db_Nm;
        paramTmp.conn_Fldr_Id = this.conn_Fldr_Id;
        paramTmp.paramDTyp_Nm = this.paramDTyp_Nm;
        paramTmp.showParamPrec = this.showParamPrec;

        paramTmp.showParamScale = this.showParamScale;
        paramTmp.maxParamPrec = this.maxParamPrec;
        paramTmp.maxParamScale = this.maxParamScale;
        paramTmp.prm_Lnk_Obj_Nm = this.prm_Lnk_Obj_Nm;
        paramTmp.hideParamDTyp_Id = this.hideParamDTyp_Id;
        paramTmp.isEditable = this.isEditable;
        paramTmp.fldr_Id = this.fldr_Id;
        paramTmp.fldrNm = this.fldrNm;
        paramTmp.change_Ind = this.change_Ind;

        paramTmp.ref_Cd = this.ref_Cd;
        paramTmp.selectedFlag = this.selectedFlag;
        paramTmp.recExists = this.recExists;
        paramTmp.forcibleFlag = this.forcibleFlag;
        paramTmp.isFileType = this.isFileType;

        return paramTmp;
    }

    copyFrom(paramTmp: Param): void {
        this.param_Id = paramTmp.param_Id;
        this.obj_Id = paramTmp.obj_Id;
        this.nm = paramTmp.nm;
        this.paramNm = paramTmp.paramNm;
        this.paramPrec = paramTmp.paramPrec;
        this.paramScale = paramTmp.paramScale;
        this.paramDTyp_Id = paramTmp.paramDTyp_Id;
        this.paramVal = paramTmp.paramVal;
        this.paramDTyp_Nm = paramTmp.paramDTyp_Nm;

        this.valid_Cd = paramTmp.valid_Cd;
        this.srt_Order = paramTmp.srt_Order;
        this.paramTyp = paramTmp.paramTyp;
        this.type = paramTmp.type;
        this.prm_Lnk_Obj_Id = paramTmp.prm_Lnk_Obj_Id;
        this.paramDefVal = paramTmp.paramDefVal;
        this.conn_Id = paramTmp.conn_Id;
        this.conn_Db_Id = paramTmp.conn_Db_Id;
        this.jobId = paramTmp.jobId;

        //      this.job_Id = paramTmp.job_Id;
        this.jobOrder = paramTmp.jobOrder;
        this.copyParamVal = paramTmp.copyParamVal;
        this.copyValid_Cd = paramTmp.copyValid_Cd;
        this.ref_Id = paramTmp.ref_Id;
        this.error_Cd = paramTmp.error_Cd;
        this.error_Msg = paramTmp.error_Msg;
        this.conn_Nm = paramTmp.conn_Nm;

        this.conn_Db_Nm = paramTmp.conn_Db_Nm;
        this.conn_Fldr_Id = paramTmp.conn_Fldr_Id;
        this.paramDTyp_Nm = paramTmp.paramDTyp_Nm;
        this.type = paramTmp.type;
        this.showParamPrec = paramTmp.showParamPrec;
        this.showParamScale = paramTmp.showParamScale;
        this.maxParamPrec = paramTmp.maxParamPrec;
        this.maxParamScale = paramTmp.maxParamScale;

        this.prm_Lnk_Obj_Nm = paramTmp.prm_Lnk_Obj_Nm;
        this.hideParamDTyp_Id = paramTmp.hideParamDTyp_Id;
        this.isEditable = paramTmp.isEditable;
        this.fldr_Id = paramTmp.fldr_Id;
        this.fldrNm = paramTmp.fldrNm;
        this.change_Ind = paramTmp.change_Ind;
        this.ref_Cd = paramTmp.ref_Cd;
        this.selectedFlag = paramTmp.selectedFlag;
        this.recExists = paramTmp.recExists;
        this.forcibleFlag = paramTmp.forcibleFlag;
        this.isFileType = paramTmp.isFileType;
    }

    compare(paramTmp: Param): string {
        let paramString: string = this.toString(false);
        let paramTmpString: string = paramTmp.toString(false);

        if (paramString != paramTmpString) {
            return paramString + ', ' + paramTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true) {
        let str: string = "Param [param_Id=" + this.param_Id + ", obj_Id=" + this.obj_Id + ", nm=" + this.nm +
            ", paramNm=" + this.paramNm + ", paramPrec=" + this.paramPrec + ", paramScale=" + this.paramScale +
            ", paramDtyp_Id=" + this.paramDTyp_Id + ",  paramVal=" + this.paramVal + ", valid_Cd=" + this.valid_Cd +
            ", srt_Order=" + this.srt_Order + ", paramTyp=" + this.paramTyp + ", type=" + this.type +
            ", prm_Lnk_Obj_Id =" + this.prm_Lnk_Obj_Id + ", paramDefval=" + this.paramDefVal + ", conn_Id=" + this.conn_Id +
            ", conn_Db_Id=" + this.conn_Db_Id + ", jobOrder =" + this.jobOrder + ", jobId =" + this.jobId + ", isFileType =" + this.isFileType;
          
           

        // ", job_id=" + this.job_Id + 
        if (isNotCompare) {
            str += ", ref_Id=" + this.ref_Id + ", error_Cd=" + this.error_Cd + ", ref_Cd  =" + this.ref_Cd +
                ", error_Msg =" + this.error_Msg + ", fldr_Id=" + this.fldr_Id +
                ", fldrNm=" + this.fldrNm + ", change_Ind =" + this.change_Ind;
        }

        str += ']';
        return str;
    }
}